import React from 'react';
import TickIcon from '../icons/TickIcon';
import classnames from 'classnames';

export default class ColorBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked != null ? props.checked : false
        }
    }

    onChange = (e) => {
        e.stopPropagation();

        if (this.props.onCheck) {
            this.props.onCheck(e, this.input.checked)
        }
    }

    render() {
        const {
            checked,
            disabled,
            hexColor,
            showTick,
            value,
            isMobile
        } = this.props;

        const divClassName = classnames(
            'color-box',
            {
                'color-box_checked': checked
            }
        );

        const backgroundColor = hexColor && `linear-gradient(135deg, ${hexColor[0]} 50%, ${hexColor[1]} 50%)`;

        return (
            <label className='color-box__label'>
                <div
                    className={divClassName}
                    style={{
                        background: backgroundColor,
                        border: value === 'белый' ? '1px solid #CCC' : isMobile ? '2px solid #fff' : '1px solid #fff',
                    }}
                >
                    <input
                        ref={input => {
                            this.input = input
                        }}
                        value={this.state.checked}
                        checked={checked || false}
                        name={name}
                        type="checkbox"
                        disabled={disabled}
                        onChange={this.onChange}
                        className='color-box__fake'
                    />
                    {showTick &&
                        <span>
                            {checked && <TickIcon className='color-box__tick' />}
                        </span>
                    }
                </div>
            </label>
        )
    }
}